import React from "react";
import NavBar from "../navBar";
import Footer from "../footer";

const Main = (props) => {
  return (
    <>
      <NavBar />
      <div className="">{props.children}</div>
      <Footer />
    </>
  );
};

export default Main;
